import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography, Chip } from "@mui/material";
import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import styles from "./style";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../../components/CustomPagination";
import Modal from "../../../../../components/Modal";
import { formatDate } from "../../../../../utils/DateFormat";


const DeductionList = ({ data, getDeductionType, page, setPage, total, handleDelete, setFrom, setOpen, setItem, setChange, permission, role }) => {
  const [opens, setOpens] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleNavigate = (item) => {
    getDeductionType()

    setItem(item);
    setOpen(true);
    setFrom("edit");
    setChange("false");

  }
  const navigate = useNavigate()

  const handleNavigateView = (item) => {
    navigate("/dashboard/viewDeduction", { state: { item } })
  }
  const [value, setValue] = useState();

  const deleteData = (item) => {
    setValue(item);

  }
  const handleDeleteItem = () => {
    handleDelete(value);
    setOpens(false);
  };

  const getStatusChipStyles = (status) => {
    if (!status) {
      return {
        backgroundColor: "default",
        color: "inherit"
      };
    }
    const statusLower = status.toLowerCase();
    if (statusLower === "active" || statusLower === "open") {
      return {
        backgroundColor: "#cef5d6",
        color: "#126300"
      };
    }
    if (statusLower === "paid") {
      return {
        backgroundColor: "#cef5d6",
        color: "#126300"
      };
    }
    if (statusLower === "closed") {
      return {
        backgroundColor: "#f5f5f5",
        color: "#666"
      };
    }
    if (statusLower === "complete" || statusLower === "completed") {
      return {
        backgroundColor: "#d4edda",
        color: "#155724"
      };
    }
    if (statusLower === "pending") {
      return {
        backgroundColor: "#fff3cd",
        color: "#856404"
      };
    }
    return {
      backgroundColor: "default",
      color: "inherit"
    };
  };

  const isStatusDisabled = (status) => {
    const statusLower = status?.toLowerCase();
    return statusLower === "closed" || 
           statusLower === "complete" || 
           statusLower === "completed" ||
           statusLower === "paid";
  };

  const hasTransactions = (item) => {
    const deduction = item?.deductions?.[0];
    const totalAmount = Number(deduction?.rateValue) || 0;
    const leftBalance = Number(deduction?.leftBalance);
    const paidAmount = Number(deduction?.paidAmount) || 0;
    
    if (paidAmount > 0) return true;
    if (leftBalance !== undefined && leftBalance !== null && leftBalance < totalAmount) return true;
    if (deduction?.transactionCount > 0) return true;
    
    return false;
  };

  const isEditDisabled = (item) => {
    const status = item?.deductions?.[0]?.status;
    return isStatusDisabled(status) || hasTransactions(item);
  };

  return (
    <>


      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>Issued Date</TableCell>
              <TableCell sx={styles.TableHead}>Type</TableCell>
              <TableCell sx={styles.TableHead}>Amount</TableCell>
              <TableCell sx={styles.TableHead}>Total Amount</TableCell>
              <TableCell sx={styles.TableHead}>Paid Amount</TableCell>
              <TableCell sx={styles.TableHead}>Left Balance</TableCell>
              <TableCell sx={styles.TableHead}>Payment Method</TableCell>
              <TableCell sx={styles.TableHead}>Status</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src={item?.employeeDetails?.personalInfo?.image} sx={{ mr: "8px" }} /><Box >
                      <Typography sx={styles.name}>{item?.employeeDetails?.personalInfo?.firstName} {item?.employeeDetails?.personalInfo?.surName}</Typography>

                      <Typography sx={styles.mail}>{item?.email}</Typography>
                    </Box>       </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {item?.createdAt ? formatDate(item.createdAt) : "-"}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.deductions?.[0]?.type}</TableCell>


                  <TableCell sx={styles.tabledata}>{item?.deductions?.[0]?.rateValue ?? "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.deductions?.[0]?.totalAmount ?? "-"}</TableCell>
                <TableCell sx={styles.tabledata}>{item?.deductions?.[0]?.paidAmount ?? "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.deductions?.[0]?.leftBalance ?? "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.deductions?.[0]?.paymentMethod || "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Chip
                      label={item?.deductions?.[0]?.status || "-"}
                      size="small"
                      sx={{
                        fontWeight: 500,
                        textTransform: "capitalize",
                        ...getStatusChipStyles(item?.deductions?.[0]?.status)
                      }}
                    />
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      {(permission?.deduction?.isEdit || role === "Admin" || role === "SuperAdmin") ? (
                        <Edit
                          onClick={() => {
                            if (!isEditDisabled(item)) {
                              handleNavigate(item);
                            }
                          }}
                          style={{
                            opacity: isEditDisabled(item) ? 0.3 : 1,
                            cursor: isEditDisabled(item) ? "not-allowed" : "pointer",
                            pointerEvents: isEditDisabled(item) ? "none" : "auto"
                          }}
                        />
                      ) : null}
                      <RemoveRedEyeOutlinedIcon onClick={() => handleNavigateView(item)} sx={styles.viewIcon} />

                      {(permission?.deduction?.isEdit || role === "Admin" || role === "SuperAdmin") ? <DeleteOutlineIcon sx={{ color: "#ff0000" }} onClick={() => {
                        deleteData(item?._id), setOpens(true);
                      }} /> : null}
                    </Box>
                  </TableCell>
                </TableRow>


              )))}

          </TableBody>

        </Table>

        {data &&
          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}


      </TableContainer>


      <Modal open={opens} setOpen={setOpens} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Deduction"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>

        </Box>
      </Modal>    </>);
};
export default DeductionList;
